(ns practitest.frontend.sections
  (:require    [practitest.frontend.pt-ts-bridge :refer [FormLayoutWrapper, TranslationProvider, DeletionPreventionModal]]
               [cljs.core :refer [clj->js]]
               [practitest.frontend.common.i18n :refer [get-translation]]
               [practitest.frontend.common-entities.metadata :refer [get-entity-name]]
               [practitest.frontend.components.project-settings-tabs :as project-settings-tabs]
               [practitest.frontend.components2.spinners :refer [mux-spinner]]
               [practitest.frontend.routing.router :as router]
               [practitest.frontend.sections.events :as section]
               [practitest.frontend.events :as events]
               [practitest.frontend.subs :as subs]
               [re-frame.core :as re-frame]
               [reagent.core :as reagent]))

(def handle-save-sections
  (fn [payload on-success]
    (re-frame/dispatch [::section/save-sections payload on-success])))

(defn handle-close-deletion-prevention-modal []
  (re-frame/dispatch [::section/close-deletion-prevention-modal]))

(defn index []
  (reagent/with-let [_ (do (re-frame/dispatch [::section/fetch-settings-fields])
                           (re-frame/dispatch [::events/fetch-sections true]))]
    (let [current-params (router/get-current-query-params)
          entity (:entity current-params)
          project-id @(re-frame/subscribe [::subs/current-project-id])
          groups @(re-frame/subscribe [::subs/groups])
          handle-entity-change (fn [new-entity]
                                 (router/update-query-params! assoc :entity new-entity))
          all-entities-field-data @(re-frame/subscribe [::subs/all-entity-fields])
          integrated-fields @(re-frame/subscribe [::subs/integrated-fields]) 
          all-entities-available-fields-data @(re-frame/subscribe [::subs/settings-fields])
          all-entity-sections @(re-frame/subscribe [::subs/all-entity-sections])
          test-case-versioning-enabled? @(re-frame/subscribe [::subs/test-case-versioning-enabled?])
          deletion-prevention-data @(re-frame/subscribe [::subs/sections-deletion-prevention-data])
          tab-opts (if (empty? entity)
                     {}
                     {:breadcrumbs [{:label (str (get-translation "sections.edit-form.project-settings-part2" "Forms Layout Edit")
                                                 " - "
                                                 (get-entity-name (keyword entity) :singular-name))}]})]
      [:div.sections-page
       [project-settings-tabs/project-settings-tabs tab-opts]
       (cond
         ;; Loading state when any required data is not ready
         (or (nil? all-entities-available-fields-data)
             (empty? entity)
             (empty? groups)
             (nil? all-entity-sections)
             (nil? all-entities-field-data)
             (empty? all-entity-sections))
         [:div {:class "centered-spinner"}
          [mux-spinner]]

         ;; Render FormLayoutWrapper only when all required data is ready
         :else
         [:> TranslationProvider
          [:<>
           [:> FormLayoutWrapper {:entity entity
                                  :allEntitiesAvailableFieldsData all-entities-available-fields-data
                                  :projectId project-id
                                  :allEntitiesFieldData all-entities-field-data
                                  :integratedFields integrated-fields
                                  :handleSave #(handle-save-sections (js->clj %1 :keywordize-keys true) %2)
                                  :allEntitiesSectionData (clj->js all-entity-sections)
                                  :handleEntityChange handle-entity-change
                                  :testCaseVersioningEnabled test-case-versioning-enabled?}]
           [:> DeletionPreventionModal {:show (some? deletion-prevention-data)
                                        :onHide handle-close-deletion-prevention-modal
                                        :title (get-translation "sections.modal.deletion-prevention.title" "Failed to Unlink Field")
                                        :usedInLabel (get-translation "sections.modal.deletion-prevention.used-in" "Please review the following items and unlink the field before continuing:")
                                        :deletionPreventionData (clj->js deletion-prevention-data)}]]])])))
   
